@if (company_id !== null) {
  <app-locations-management [relatable_type]="relatable_type" [relatable_id]="company_id" />
} @else if (!is_loading) {
  <p class="no-company-message">Este producto no tiene ninguna empresa asociada.</p>
}
